module.exports = __webpack_public_path__ + "static/media/icon-projects.233b0186.svg";